
define('text!setup/setup.html',[],function () { return '<div class="setup">\n    <div data-bind="compose: header"></div>\n    <div data-bind="router, visible: !router.isNavigating()"></div>\n    <div data-bind="compose: \'footer/footer\'"></div>\n</div>\n';});

